import Chart from "react-apexcharts";

const ChartUI = ({ text }) => {
  const state = {
    options: {
      chart: {
        id: text,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        width: [1, 0, 0],
        colors: ["#20AE77"],
        background: ["#D0FFED"],
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div class="text-red-500 w-[180.4px] md:w-[229.4px] h-[139.73px] bg-[#262F59] rounded-br-[20.8548] rounded-bl-none rounded-tr-[20.8548] rounded-tl-[20.8548]">' +
            "<p class='h-[39.62px] leading-[39.62px] bg-[#37406D] text-[#BBC1E2] pl-4'>" +
            "Jan 02, 2020" +
            "</p>" +
            "<div class='flex pl-3 pr-3 justify-between mt-5 items-center'>" +
            "<p class='text-[#DBE0FF]'>" +
            "Sales" +
            "</p>" +
            "<span class='text-[#20AE77]'>" +
            series[seriesIndex][dataPointIndex] +
            "</span>" +
            "</div>" +
            "<div class='flex pl-3 pr-3 justify-between mt-3 items-center'>" +
            "<p class='text-[#DBE0FF]'>" +
            "Amount" +
            "</p>" +
            "<span class='text-white'>" +
            "#20,000" +
            "</span>" +
            "</div>" +
            "</div>"
          );
        },
      },
      xaxis: {
        categories: [
          "Jan 01",
          "Jan 02",
          "Jan 03",
          "Jan 04",
          "Jan 05",
          "Jan 06",
          "Jan 07",
          "Jan 08",
          "Jan 09",
        ],
      },
    },
    series: [
      {
        name: "sales:",

        data: [30, 24, 20, 25, 49, 60],
      },
    ],
  };

  return (
    <div
      className="border-[0.5px] border-[#DEE2F3] rounded p-3 mt-8"
      id="chartContainer"
    >
      <h4>{text}</h4>
      <Chart
        options={state.options}
        series={state.series}
        type="area"
        height={400}
      />
    </div>
  );
};

export default ChartUI;
